import React, { useEffect, useState } from "react";
import Progress from "./progress/Progress";
import Box from "../../../../Flows/Student/Dashboard/EduProg/box/Box";
import UserProfileMobile from "../../../../components/FlowComponents/userProfileMobile/UserProfileMobile";
import { db } from "../../../../firebase-config";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { useAuth } from "../../../../provider/Auth.provider";
import { findUserByUID } from "../../../../service/findUsers/findUserByUID";
import styles from "./Edu.module.css";

// Importing assets
import userLogo from "../assets/users.png";

export async function getCourseIdsOfStudent(student_uid) {
  try {
    if (!student_uid) {
      console.error("No student_uid provided");
      return [];
    }

    const userDocRef = doc(db, "users", student_uid);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      const userData = userDoc.data();
      // Ensure buyItemIdsArray exists and is an array, default to empty array if not
      const buyItemIdsArray = Array.isArray(userData.buyItemIdsArray)
        ? userData.buyItemIdsArray
        : [];
      console.log("buyItemIdsArray:", buyItemIdsArray);

      // Return only the buyItemId values, ensuring item is an object with buyItemId
      return buyItemIdsArray
        .filter((item) => item && typeof item === "object" && item.buyItemId)
        .map((item) => item.buyItemId);
    } else {
      console.log("No such user found!");
      return [];
    }
  } catch (error) {
    console.error("Error fetching user document:", error);
    return [];
  }
}

export async function getLiveApprovedPackageIdsOfStudent(student_uid) {
  try {
    if (!student_uid) {
      console.error("No student_uid provided");
      return [];
    }

    const userSnap = await getDoc(doc(db, "users", student_uid));
    if (!userSnap.exists()) {
      console.log("No such user found!");
      return [];
    }

    const userData = userSnap.data();
    const buyItemIdsArray = Array.isArray(userData.buyItemIdsArray)
      ? userData.buyItemIdsArray
      : [];

    // Filter to only package_lc items and map to IDs
    const ids = buyItemIdsArray
      .filter(
        (item) =>
          item &&
          typeof item === "object" &&
          item.buyItemType === "package_lc" &&
          item.status === "approved" &&
          item.buyItemId
      )
      .map((item) => String(item.buyItemId));

    // Optional: dedupe
    return Array.from(new Set(ids));
  } catch (error) {
    console.error("Error fetching user document:", error);
    return [];
  }
}
const Edu = () => {
  const { user } = useAuth();
  const [userData, setUserData] = useState(null);
  // const [courseData, setCourseData] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!user?.uid) {
        console.error("No user UID available");
        setIsLoading(false);
        return;
      }

      try {
        const userData = await findUserByUID(user.uid);
        setUserData(userData);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, [user?.uid]);

  useEffect(() => {
    const fetchPackageData = async () => {
      if (!user?.uid) {
        console.error("No user UID available");
        setIsLoading(false);
        return;
      }

      try {
        const data = await findCoursesData(user.uid);
        console.log("Fetched course data:", data);
        setPackageData(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching course data:", error);
        setPackageData([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPackageData();
  }, [user?.uid]);

  async function findCoursesData(student_uid) {
    try {
      // Fetch all course IDs the student has purchased
      const buyItemIdsArray = await getLiveApprovedPackageIdsOfStudent(
        student_uid
      );

      console.log("Course IDs array:", buyItemIdsArray);

      if (!buyItemIdsArray.length) {
        console.log("No course IDs found for this student");
        return [];
      }

      const lmsPackageCollection = collection(db, "lms_package");
      // Use where with "in" clause for batch fetching (Firestore 'in' supports up to 10 items)
      const packageQuery = query(
        lmsPackageCollection,
        where("packageId", "in", buyItemIdsArray)
      );

      const packageSnapshot = await getDocs(packageQuery);
      const packageDetails = packageSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log("Fetched package details:", packageDetails);
      return packageDetails;
    } catch (error) {
      console.error("Error fetching course data:", error);
      return [];
    }
  }
  const certificateLength = userData?.certificateRecords
    ? Object.keys(userData?.certificateRecords).length
    : 0;

  function countPresentAttendances(userData) {
    let presentCount = 0;

    for (const [key, value] of Object.entries(userData)) {
      if (key.startsWith("batch_attendance_") && typeof value === "object") {
        for (const record of Object.values(value)) {
          if (record.attendanceStatus === "present") {
            presentCount++;
          }
        }
      }
    }
    return presentCount;
  }
  const presentCount = userData && countPresentAttendances(userData);

  function countUniqueBatches(userData) {
    const batchKeys = Object.keys(userData).filter((key) =>
      key.startsWith("batch_attendance_")
    );
    return batchKeys.length;
  }

  const uniqueBatchCount = userData && countUniqueBatches(userData);
  const attendancePercentage =
    (presentCount / userData?.buyItemIdsArray.length) * 100;
  return (
    <div className={styles.edu}>
      <UserProfileMobile userData={userData} />
      <div className={styles.progressCharts}>
        <h1 className={styles.heading}>Education & Progress</h1>
        <div className={styles.boxes}>
          <Box
            subhed={"My Packages"}
            value={userData?.buyItemIdsArray.length}
            logo={userLogo}
          />
          <Box
            subhed={"Attendance"}
            value={attendancePercentage.toFixed(2) + " % "}
            logo={userLogo}
          />
          <Box
            subhed={"Batch Enrollments"}
            value={uniqueBatchCount}
            logo={userLogo}
          />
          <Box
            subhed={"Completed Courses"}
            value={certificateLength}
            logo={userLogo}
          />
        </div>
      </div>

      <div className={styles.courses}>Your Installment</div>
      {isLoading ? (
        <div>Loading courses...</div>
      ) : packageData.length > 0 ? (
        <Progress data={packageData} />
      ) : (
        <div>No package found. Enroll in a package. Else contact admin.</div>
      )}
    </div>
  );
};

export default Edu;
